module.exports = __webpack_public_path__ + "img/73.a767815b.jpg";